module.exports = __webpack_public_path__ + "static/media/trainVideo10.9bc98e74.mp4";